import React from "react";
import Login from "./components/Login";
import Login2 from "./components/Login2";
import Login3 from "./components/Login3";

function App() {
  return (
    <div>
      <Login />
      <Login2 />
      <Login3 />
    </div>
  );
}

export default App;
